export const ACCESS_TOKEN_KEY = 'access_token';

export const CATEGORIES = [
  'Accessory Structure',
  'Bath Remodel',
  'Demolition',
  'Exterior Remodel',
  'Foundation',
  'Kitchen Remodel',
  'New ADU',
  'New Dwelling',
  'Pool/Spa',
  'Re-roof',
  'Room Addition',
  'Sitework',
  'Solar',
  'Utilities',
  'Window/Door',
];

export const STATUSES = [
  'In Review',
  'Active',
  'Final',
  'Inactive',
];

export const MAX_ROWS = 100000;

export const CA_COUNTIES = [
  'Alameda County',
  'Alpine County',
  'Amador County',
  'Butte County',
  'Calaveras County',
  'Colusa County',
  'Contra Costa County',
  'Del Norte County',
  'El Dorado County',
  'Fresno County',
  'Glenn County',
  'Humboldt County',
  'Imperial County',
  'Inyo County',
  'Kern County',
  'Kings County',
  'Lake County',
  'Lassen County',
  'Los Angeles County',
  'Yolo County',
  'Madera County',
  'Marin County',
  'Mariposa County',
  'Mendocino County',
  'Merced County',
  'Modoc County',
  'Mono County',
  'Monterey County',
  'Napa County',
  'Nevada County',
  'Orange County',
  'Placer County',
  'Plumas County',
  'Riverside County',
  'Sacramento County',
  'San Benito County',
  'San Bernardino County',
  'San Diego County',
  'Santa Barbara County',
  'San Francisco County',
  'San Joaquin County',
  'San Luis Obispo County',
  'San Mateo County',
  'Santa Clara County',
  'Santa Cruz County',
  'Shasta County',
  'Sierra County',
  'Siskiyou County',
  'Solano County',
  'Sonoma County',
  'Stanislaus County',
  'Sutter County',
  'Tehama County',
  'Trinity County',
  'Tulare County',
  'Tuolumne County',
  'Ventura County',
  'Yuba County',
];

export const CA_MSAS = [
  'Bakersfield, CA',
  'Chico, CA',
  'El Centro, CA',
  'Fresno, CA',
  'Hanford-Corcoran, CA',
  'Los Angeles-Long Beach-Anaheim, CA',
  'Madera, CA',
  'Merced, CA',
  'Modesto, CA',
  'Napa, CA',
  'Oxnard-Thousand Oaks-Ventura, CA',
  'Redding, CA',
  'Riverside-San Bernardino-Ontario, CA',
  'Sacramento-Roseville-Folsom, CA',
  'Salinas, CA',
  'San Diego-Chula Vista-Carlsbad, CA',
  'San Francisco-Oakland-Berkeley, CA',
  'San Jose-Sunnyvale-Santa Clara, CA',
  'San Luis Obispo-Paso Robles, CA',
  'Santa Cruz-Watsonville, CA',
  'Santa Maria-Santa Barbara, CA',
  'Santa Rosa-Petaluma, CA',
  'Stockton, CA',
  'Vallejo, CA',
  'Visalia, CA',
  'Yuba City, CA',
];

export const IS_ADMIN = 'is_admin';